<template>
	<div style="height: 100%">
		<div class="buttonBox" v-if="showButton">
			<div>
				<div class="chooseButton searchButton" @click="deviceCheckItemInfoEdit('1')"
					v-if="MenuRoleList.indexOf('14')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
				</div>
				<div class="chooseButton searchButton " @click="deviceCheckItemInfoEdit('2')"
					v-if="MenuRoleList.indexOf('15')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
				</div>
				<div class="chooseButton searchButton " @click="deviceCheckItemInfoEdit('3')"><i
						class="el-icon-edit-outline"></i>{{$t('label_948')}}
				</div>
				<div class="chooseButton deleteButton" @click="delEquipmentTypeCheckItem"
					v-if="MenuRoleList.indexOf('16')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
			</div>
		</div>
		<div class="buttonBox" style="margin-left: -2px;" v-if="!showButton">
			<div>
				<div class="chooseButton searchButton" style="width: 140px;" @click="checkInfoExportExcel"
					v-if="$store.getters.getVersions == 4">
					<i class="el-icon-download"></i>{{$t('btn_10')}}
				</div>
			</div>
		</div>
		<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row
			@current-change="handleCurrentChangeTree" border style="width: 100%;margin: 10px 0 10px 0px"
			height="calc(100% - 100px)" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
			<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
				:index="getIndex" width="50">
			</el-table-column>
			<el-table-column prop="name" :label="$t('label_533')" align="left" width="300">
				<template slot-scope="scope">
					<span style="font-size: 16px; font-weight: 600;">
						{{scope.row.name}}
					</span>
					<br>
					<popMesBox :popMes="scope.row.content" :hoverMes="scope.row.content" :popWidth="200"></popMesBox>
				</template>
			</el-table-column>
			<el-table-column prop="cycle" :label="$t('label_741')" align="center">
				<template slot-scope="scope">
					<template
						v-if="scope.row.cycleType=='1'">{{scope.row.cycle=='0'?$t('label_652'):$t('label_531')+scope.row.cycle+$t('label_537')}}</template>
					<template
						v-if="scope.row.cycleType=='2'">{{scope.row.cycle==0?weekendMesOptions[6].label:weekendMesOptions[scope.row.cycle-1].label}}</template>
					<template
						v-if="scope.row.cycleType=='3'">{{scope.row.cycle>20?$t('label_238')+scope.row.cycle+$t('label_537'):scope.row.cycle>10?$t('label_242')+scope.row.cycle+$t('label_537'):$t('label_245')+scope.row.cycle+$t('label_537')}}</template>
					<template
						v-if="scope.row.cycleType=='8'">{{$t('label_531')+scope.row.cycle+$t('label_743')}}</template>
					<template
						v-if="scope.row.cycleType=='9'">{{$t('label_531')+scope.row.cycle+$t('label_542')}}</template>
				</template>
			</el-table-column>
			<el-table-column prop="method" :label="$t('label_742')" align="center">
				<template slot-scope="scope">
					{{checkText(scope.row.method)}}
				</template>
			</el-table-column>
			<el-table-column prop="defaultValue" :label="$t('label_368')" align="center">
				<template slot-scope="scope">
					{{checkDefaultValue(scope.row)}}
				</template>
			</el-table-column>
			<el-table-column prop="method" :label="$t('label_340')" align="center">
				<template slot-scope="scope">
					{{positionText(scope.row.positionCode)}}
				</template>
			</el-table-column>
			<el-table-column prop="sort" v-if="needSort" :label="$t('label_501')" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="moveUp(scope.row, scope.$index)"
						:disabled="getIndex(scope.$index) === 1" style="font-size: 20px"><i
							class="el-icon-arrow-up"></i>
					</el-button>
					<el-button type="text" size="small" style="font-size: 20px"
						@click="moveDown(scope.row, scope.$index)" :disabled="getFormLength(getIndex(scope.$index))"><i
							class="el-icon-arrow-down"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
			v-show="showPage" @parentMethod="searchPage"></Page>

		<el-dialog v-loading="saveLoading" :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body
			:close-on-click-modal='false' width="800px" top="5%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_533')}}</p>
						<div class="mesInput">
							<el-input v-model="tableDataEdit.name" maxlength="20" show-word-limit></el-input>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 100px">
						<p><span style="color: #ff0000">*</span>{{$t('label_742')}}</p>
						<div class="mesInput">
							<el-select v-model="tableDataEdit.method" filterable :placeholder="$t('input_65')">
								<el-option v-for="item in checkList" :key="item.key" :label="item.val"
									:value="item.key">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_340')}}</p>
						<div class="mesInput">
							<el-select v-model="tableDataEdit.positionCode" filterable :placeholder="$t('input_65')">
								<el-option v-for="item in positionList" :key="item.code" :label="item.name"
									:value="item.code">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<!-- <span style="color: #ff0000">*</span> -->
					<p>{{$t('label_212')}}</p>
					<div class="mesInput" style="width: 640px">
						<el-input type="textarea" :placeholder="$t('input_65')" maxlength="200" show-word-limit
							v-model="tableDataEdit.content"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_741')}}</p>
					<div class="mesInput" style="display: flex;width: 640px">
						<el-radio-group v-model="tableDataEdit.cycleType" @change="agreeChange">
							<el-radio label="1">
								<span style="line-height: 40px">{{$t('label_652')}}</span>
							</el-radio>
							<el-radio label="2">
								<el-select v-model="tableDataEdit.weekend" style="width: 110px" filterable
									:placeholder="$t('input_65')" :disabled="tableDataEdit.cycleType!='2'">
									<el-option v-for="item in weekendMesOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-radio>
							<el-radio label="3">
								<el-select style="width: 90px" v-model="tableDataEdit.month" filterable
									:placeholder="$t('input_65')" :disabled="tableDataEdit.cycleType!='3'"
									@change="changeSelectMonth">
									<el-option v-for="(item,index) in monthOptions" :key="index" :label="item"
										:value="item">
									</el-option>
								</el-select><strong></strong>
								<el-select style="width: 90px" v-model="tableDataEdit.monthD"
									:placeholder="$t('input_65')" :disabled="tableDataEdit.cycleType!='3'"
									@change="$forceUpdate()">
									<el-option v-for="(item33,index33) in monthDOptions" :key="index33" :label="item33"
										:value="item33" />
								</el-select>
							</el-radio>
							<el-radio label="4" style="margin-right: 0">{{$t('label_531')}}
								<el-input v-model="tableDataEdit.monthDMes" style="width: 60px"
									:disabled="tableDataEdit.cycleType!='4'"></el-input>
								{{$t('label_537')}}
							</el-radio>
							<el-radio label="8" style="margin-top: 5px">{{$t('label_531')}}
								<el-input v-model="tableDataEdit.monthWMes" @input='changeInput()' style="width: 60px"
									:disabled="tableDataEdit.cycleType!='8'"></el-input>
								{{$t('label_743')}}
							</el-radio>
							<el-radio label="9" style="margin-top: 5px">{{$t('label_531')}}
								<el-input v-model="tableDataEdit.monthMMes" @input='changeInput()' style="width: 60px"
									:disabled="tableDataEdit.cycleType!='9'"></el-input>
								{{$t('label_542')}}
							</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_888')}}</p>
					<div class="mesInput">
						<el-input v-model="tableDataEdit.timeLimit" style="width: 80px; margin-right: 5px;"
							:disabled="tableDataEdit.cycleType=='1'"></el-input>{{$t('label_889')}}
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_847')}}</p>
					<div class="mesInput" style="display: flex;width: 640px;padding-top: 13px">
						<el-radio label="1" v-model="tableDataEdit.inputType">{{$t('label_145')}}</el-radio>
						<el-radio label="2" v-model="tableDataEdit.inputType">{{$t('label_149')}}</el-radio>
						<el-radio label="3" v-model="tableDataEdit.inputType">{{$t('label_141')}}</el-radio>
					</div>
				</div>
				<div class="dialogMes">
					<p></p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;padding-top: 13px;padding-left:15px"
                                v-if="tableDataEdit.inputType != '3'">

								<p style="width: 170px"><span style="color: #ff0000">*</span>{{$t('label_849')}}</p>
								<p style="width: 160px"><span style="color: #ff0000">*</span>{{$t('label_848')}}</p>
								<p style="width: 160px">{{$t('btn_25')}}</p>
							</div>
							<div class="select" style="display: flex;">
								<div class="selectMes"
									style="width: 450px;border:1px solid #dedede;padding: 10px;height: 160px;overflow:auto;">
									<div class="mes" style="display: flex;margin-bottom: 10px"
										v-for="(item,index) in checkMesList" v-if="tableDataEdit.inputType!='3'">
										<el-input style="width: 150px" v-model="checkMesList[index].name"></el-input>
										<el-select style="width: 150px;margin-left:20px"
											v-model="checkMesList[index].check">
											<el-option v-for="item in oddList" :key="item.val" :label="item.label"
												:value="item.val"></el-option>
										</el-select>
										<div class="choose" style="padding-top: 13px;margin-left: 20px">
											<el-checkbox v-model="checkMesList[index].default" value="1"
												@change="changeDefault(index)"></el-checkbox>
										</div>
										<div class="del" v-if="checkMesList.length>1"
											style="padding-top: 13px;margin-left: 20px;cursor: pointer"
											@click="delCheckList(index)"><i class="el-icon-remove"
												style="color: #ff3300;font-size: 20px"></i>
										</div>
									</div>
									<div class="add" style="width: 30px;cursor: pointer" @click="addChooseList"
										v-if="tableDataEdit.inputType!='3'">
										<i class="el-icon-circle-plus" style="font-size: 22px;color:#0353c1 "></i>
									</div>
                  <div v-if="tableDataEdit.inputType == '3'">
										<el-radio label="1"
											v-model="tableDataEdit.radioType">{{$t('label_141')}}</el-radio>
										<el-radio label="2"
											v-model="tableDataEdit.radioType">{{$t('label_138')}}</el-radio>
									</div>
									<div style="padding-top: 20px; "
										v-if="tableDataEdit.radioType != '1' && tableDataEdit.inputType == '3'">
										<div style="display: flex;">
											<p style="width: 90px;">{{$t('label_955')}}</p>
											<span style="margin-top: 10px;">{{$t('label_957')}}&nbsp;</span><el-input
												v-model="tableDataEdit.accuracy"
												style="width: 50px; padding-bottom: 10px;"
												oninput="value=value.replace(/[^\d]/g,'')"></el-input><span
												style="margin-top: 10px;">&nbsp;{{$t('label_956')}}</span>
										</div>
										<div style="display: flex;">
											<p style="width: 90px;">{{$t('label_954')}}</p>
											<el-input v-model="tableDataEdit.radioNum1" style="width: 160px;"
												oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
											<span
												style="text-align: center; padding-top: 8px;">&nbsp;-&nbsp;</span><el-input
												v-model="tableDataEdit.radioNum2" style="width: 160px;"
												oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
										</div>
									</div>
								</div>
								<div class="photoStyle">
									<div class="box" @click="choosePhoto?(choosePhoto = false):(choosePhoto = true)"
										:class="choosePhoto?'choosePhoto':''">
										<div class="choose"></div>
										<i class="el-icon-camera"></i>
									</div>
									<p style="line-height: 20px">{{$t('label_806')}}</p>
									<div class="box" @click="chooseVideo?(chooseVideo = false):(chooseVideo = true)"
										:class="chooseVideo?'chooseVideo':''">
										<div class="choose"></div>
										<i class="el-icon-video-camera"></i>
									</div>
									<p style="line-height: 20px">{{$t('label_863')}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p v-if="$store.getters.getVersions == 2" style="width: 100px;line-height: 25px">
						{{$t('label_555')}}(E-SOP)
					</p>
					<p v-else style="width: 100px;line-height: 25px">{{$t('label_555')}}</p>
					<div class="mesInput">
						<div class="box"
							style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;">
							<el-upload v-if="chooseFile==false" class="upload-demo"
								action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false"
								:http-request="upload">
								<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
							</el-upload>
							<div v-if="chooseFile==true" style="cursor: pointer;position:relative;">
								<i class="el-icon-success" @click="previewFile"
									style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
								<i class="el-icon-circle-close" @click="delFile"
									style="font-size: 35px;color: #000000;line-height: 50px;position:absolute;right: -45px"></i>
							</div>

							<!-- <el-tooltip class="item" effect="dark" :content="showName(tableDataEdit.fileId)" placement="bottom">
								<span class="fileName">{{showName(tableDataEdit.fileId)}}</span>
							</el-tooltip> -->
						</div>
						<span>{{showNameList}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="tableDataEditSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>


		<el-dialog v-loading="saveLoadings" :title="deviceParamTitles" :visible.sync="dialogDeviceSpots" append-to-body
			:close-on-click-modal='false' width="800px" top="5%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogMes">
				<p><span style="color: #ff0000">*</span>{{$t('label_741')}}</p>
				<div class="mesInput" style="display: flex;width: 640px">
					<el-radio-group v-model="tableDataEdits.cycleType" @change="agreeChanges">
						<el-radio label="1">
							<span style="line-height: 40px">{{$t('label_652')}}</span>
						</el-radio>
						<el-radio label="2">
							<el-select v-model="tableDataEdits.weekend" style="width: 110px" filterable
								:placeholder="$t('input_65')" :disabled="tableDataEdits.cycleType!='2'">
								<el-option v-for="item in weekendMesOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-radio>
						<el-radio label="3">
							<el-select style="width: 90px" v-model="tableDataEdits.month" filterable
								:placeholder="$t('input_65')" :disabled="tableDataEdits.cycleType!='3'"
								@change="changeSelectMonths">
								<el-option v-for="(item,index) in monthOptions" :key="index" :label="item"
									:value="item">
								</el-option>
							</el-select><strong></strong>
							<el-select style="width: 90px" v-model="tableDataEdits.monthD" :placeholder="$t('input_65')"
								:disabled="tableDataEdits.cycleType!='3'" @change="$forceUpdate()">
								<el-option v-for="(item33,index33) in monthDOptions" :key="index33" :label="item33"
									:value="item33" />
							</el-select>
						</el-radio>
						<el-radio label="4" style="margin-right: 0">{{$t('label_531')}}
							<el-input v-model="tableDataEdits.monthDMes" style="width: 60px"
								:disabled="tableDataEdits.cycleType!='4'"></el-input>
							{{$t('label_537')}}
						</el-radio>
						<el-radio label="8" style="margin-top: 5px">{{$t('label_531')}}
							<el-input v-model="tableDataEdits.monthWMes" @input='changeInput()' style="width: 60px"
								:disabled="tableDataEdits.cycleType!='8'"></el-input>
							{{$t('label_743')}}
						</el-radio>
						<el-radio label="9" style="margin-top: 5px">{{$t('label_531')}}
							<el-input v-model="tableDataEdits.monthMMes" @input='changeInput()' style="width: 60px"
								:disabled="tableDataEdits.cycleType!='9'"></el-input>
							{{$t('label_542')}}
						</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="dialogMes">
				<p><span style="color: #ff0000">*</span>{{$t('label_888')}}</p>
				<div class="mesInput">
					<el-input v-model="tableDataEdits.timeLimit" style="width: 80px; margin-right: 5px;"
						:disabled="tableDataEdits.cycleType=='1'"></el-input>{{$t('label_889')}}
				</div>
			</div>

			<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row
				@selection-change="handleSelectionChange" border style="width: 100%;margin: 10px 0 10px 0px"
				height="500" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
					:index="getIndex" width="50">
				</el-table-column>
				<el-table-column prop="name" :label="$t('label_533')" align="left">
					<template slot-scope="scope">
						<span style="font-size: 16px; font-weight: 600;">
							{{scope.row.name}}
						</span>
						<br>
						<popMesBox :popMes="scope.row.content" :hoverMes="scope.row.content" :popWidth="200">
						</popMesBox>
					</template>
				</el-table-column>
				<el-table-column prop="cycle" :label="$t('label_741')" align="center">
					<template slot-scope="scope">
						<template
							v-if="scope.row.cycleType=='1'">{{scope.row.cycle=='0'?$t('label_652'):$t('label_531')+scope.row.cycle+$t('label_537')}}</template>
						<template
							v-if="scope.row.cycleType=='2'">{{scope.row.cycle==0?weekendMesOptions[6].label:weekendMesOptions[scope.row.cycle-1].label}}</template>
						<template
							v-if="scope.row.cycleType=='3'">{{scope.row.cycle>20?$t('label_238')+scope.row.cycle+$t('label_537'):scope.row.cycle>10?$t('label_242')+scope.row.cycle+$t('label_537'):$t('label_245')+scope.row.cycle+$t('label_537')}}</template>
						<template
							v-if="scope.row.cycleType=='8'">{{$t('label_531')+scope.row.cycle+$t('label_743')}}</template>
						<template
							v-if="scope.row.cycleType=='9'">{{$t('label_531')+scope.row.cycle+$t('label_542')}}</template>
					</template>
				</el-table-column>
				<el-table-column prop="method" :label="$t('label_742')" align="center">
					<template slot-scope="scope">
						{{checkText(scope.row.method)}}
					</template>
				</el-table-column>
				<el-table-column prop="defaultValue" :label="$t('label_368')" align="center">
					<template slot-scope="scope">
						{{checkDefaultValue(scope.row)}}
					</template>
				</el-table-column>
				<el-table-column prop="method" :label="$t('label_340')" align="center">
					<template slot-scope="scope">
						{{positionText(scope.row.positionCode)}}
					</template>
				</el-table-column>
				<el-table-column prop="sort" v-if="needSort" :label="$t('label_501')" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="moveUp(scope.row, scope.$index)"
							:disabled="getIndex(scope.$index) === 1" style="font-size: 20px"><i
								class="el-icon-arrow-up"></i>
						</el-button>
						<el-button type="text" size="small" style="font-size: 20px"
							@click="moveDown(scope.row, scope.$index)"
							:disabled="getFormLength(getIndex(scope.$index))"><i class="el-icon-arrow-down"></i>
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="tableDataEditSaves">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>







		<el-dialog :visible="showPdf == true  || showPicture == true" :show-close="true" :width="'80%'" append-to-body
			class="dialog-div-pre-style" :before-close="closePreviewClick" center>
			<div v-if="showPdf == true" class="dialog-body-content-base-style">
				<iframe frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+pdfUrl" width='100%'
					height="600px">
				</iframe>
			</div>
			<div v-else-if="showPicture == true" class="dialog-body-content-base-style">
				<img style="width: 100%;height: 600px;"
					:src="$store.getters.getPostUrl+'mes/sysFile/download/'+pictureUrl">
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import file from "@/assets/js/file/file.js";
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import popMesBox from "@/components/list/popover/pop";

	export default {
		name: "deviceParam",
		components: {
			Page,
			popMesBox,
		},
		props: {
			showButton: {
				type: Boolean,
				default: ''
			},
			needSort: {
				type: Boolean,
				default: true
			},
			showPage: {
				type: Boolean,
				default: true
			},
			fatherMethod: {
				type: Function,
				default: null
			}
		},
		data() {
			return {
				equipmentCheckInfoList: null,
				saveLoading: false,
				saveLoadings: false,
				showNameList: '',
				pageNum: 1,
				pageSize: 50,
				MenuRoleList: [],
				tableDataEdit: {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '1',
					decimals: 0,
					defaultValue: "",
					equipmentId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
					positionCode: '0',
					monthWMes: '1',
					monthMMes: '1',
					timeLimit: '1',
          radioType: '1',
					radioNum1: null,
					radioNum2: null,
					accuracy: null
				},
				tableDataEdits: {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '1',
					decimals: 0,
					defaultValue: "",
					equipmentId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
					positionCode: '0',
					monthWMes: '1',
					monthMMes: '1',
					timeLimit: '1',
				},
				tableDataTreeInfo: {},
				pageCount: 0,
				deviceParamTitle: this.$t('btn_14'),
				deviceParamTitles: this.$t('label_948'),
				dialogDeviceSpot: false,
				dialogDeviceSpots: false,
				choosePhoto: false,
				chooseFile: false,
				showPdf: false,
				showPicture: false,
				chooseVideo: false,
				tableData: [],
				oddList: [{
					val: '0',
					label: this.$t('label_864')
				}, {
					val: '1',
					label: this.$t('label_105')
				}],
				checkMesList: [{
					name: '',
					check: '',
					default: ''
				}],
				chooseDefault: '',
				allDeviceData: [],
				checkList: [],
				weekendMesOptions: [{
					value: '1',
					label: this.$t('label_719')
				}, {
					value: '2',
					label: this.$t('label_721')
				}, {
					value: '3',
					label: this.$t('label_723')
				}, {
					value: '4',
					label: this.$t('label_725')
				}, {
					value: '5',
					label: this.$t('label_728')
				}, {
					value: '6',
					label: this.$t('label_730')
				}, {
					value: '0',
					label: this.$t('label_716')
				}, ],
				monthDOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				monthOptionsObj: {
					// '每月初': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
					// '每月中': ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
					// '每月末': ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
				},
				searchDataList: {
					equipmentId: ''
				},
				fileList: [],
				versionFlag: 0,
				deptId: '',
				positionList: [{
					"code": "0",
					"name": this.$t('label_788')
				}],
			}
		},
		methods: {
			changeInput() {
				this.$forceUpdate(); //强制刷新
			},
			showName(row) {
				file.selectFileName(row).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.showNameList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				// return this.showNameList[row]
			},
			getPositionList(equipmentId) {
				file.getPositionList(equipmentId).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.positionList = [{
							"code": "0",
							"name": this.$t('label_788')
						}];
						if (data.data.length > 0) {
							this.positionList = this.positionList.concat(data.data);
							console.log(this.positionList)
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			positionText(code) {
				if (code == undefined) {
					return this.$t('label_788');
				}
				var data = this.positionList.filter(function(item) {
					return item.code == code;
				});
				if (data != '') {
					return data[0].name;
				}
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			changeSelectMonth() {
				this.tableDataEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataEdit.month]
					}
				}
				this.tableDataEdit.monthD = this.monthDOptions[0]
			},
			changeSelectMonths() {
				this.tableDataEdits.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataEdits.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataEdits.month]
					}
				}
				this.tableDataEdits.monthD = this.monthDOptions[0]
			},
			agreeChange(val) {
				if (val == '1') {
					this.tableDataEdit.timeLimit = '1';
				} else if (val == '2') {
					this.tableDataEdit.timeLimit = '5';
				} else if (val == '3') {
					this.tableDataEdit.timeLimit = '20';
				} else if (val == '4') {
					this.tableDataEdit.timeLimit = '1';
				} else if (val == '8') {
					this.tableDataEdit.timeLimit = '5';
					this.tableDataEdit.monthWMes = '1';
				} else if (val == '9') {
					this.tableDataEdit.timeLimit = '20';
					this.tableDataEdit.monthMMes = '1';
				}
			},
			agreeChanges(val) {
				if (val == '1') {
					this.tableDataEdits.timeLimit = '1';
				} else if (val == '2') {
					this.tableDataEdits.timeLimit = '5';
				} else if (val == '3') {
					this.tableDataEdits.timeLimit = '20';
				} else if (val == '4') {
					this.tableDataEdits.timeLimit = '1';
				} else if (val == '8') {
					this.tableDataEdits.timeLimit = '5';
					this.tableDataEdits.monthWMes = '1';
				} else if (val == '9') {
					this.tableDataEdits.timeLimit = '20';
					this.tableDataEdits.monthMMes = '1';
				}
			},
			newMes(id, versionFlag) {
				this.searchDataList.equipmentId = id;
				if (versionFlag == 1) {
					this.versionFlag = versionFlag;
				}
				this.getPositionList(id);
			},
			deptMes(id) {
				this.deptId = id;
			},
			handleExceed(files, fileList) {
				// this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
				this.$message.warning(this.$t('msg_151') + ',' + this.$t('msg_152') + files.length + this.$t('msg_153') +
					',' + this.$t('msg_154') + (files.length + fileList.length) + this.$t('msg_153'));
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			delFile() {
				this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
					confirmButtonText: this.$t('label_100'),
					cancelButtonText: this.$t('btn_1'),
					type: 'warning'
				}).then(() => {
					this.chooseFile = false;
					this.tableDataEdit.fileId = "";
				}).catch(() => {

				});
			},
			addChooseList() {
				this.checkMesList.push({
					name: '',
					check: '',
					default: ''
				}),
					this.tableDataEdit.radioType = '1';
			},
			handlePreview(file) {

			},
			changeDefault(index) {
				let that = this;
        this.tableDataEdit.radioType = '1';
				if (this.tableDataEdit.inputType == "1") {
					this.checkMesList.forEach(function(value, index2, array) {
						if (index != index2) {
							that.checkMesList[index2].default = false;
						}
					});
				}
			},
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				if (!this.showPage) {
					newParam.pageSize = 1000;
				}
				this.pageSize = newParam.pageSize;
				this.$refs['pageModel'].setCurrent(this.pageNum);
				newParam.versionFlag = this.versionFlag;
				this.getEquipmentCheckInfo(newParam)
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},
			checkText(type) {
				let typeText = type.toString();
				var data = this.checkList.filter(function(item) {
					return item.key == typeText;
				});
				if (data != '') {
					return data[0].val
				}
			},
			checkDefaultValue(value) {
				let list = JSON.parse(value.defaultValue);
				let text = '';
                if (value.inputType != '3') {
				list.forEach(function(value, index2, array) {
					if (value.check == "1") {
						text += value.name + ','
					}
				});
                } else {
					if (list[0].name != '') {
						text = list[0].name + " - " + list[1].name + ",";
					}
				}
				return text.substring(0, text.length - 1)
			},
			moveUp(item, index) {
				if (index === 0) {
					let param = {
						id: item.id,
						versionFlag: 0,
						upDown: 0
					}
					file.sortEquipmentCheckInfo2(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					let param = {
						id: item.id,
						sort: item.sort,
						id2: this.tableData[index - 1].id,
						sort2: this.tableData[index - 1].sort
					}
					file.sortEquipmentCheckInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}

			},
			// 下移
			moveDown(item, index) {
				if (index === 9) {
					let param = {
						id: item.id,
						versionFlag: 0,
						upDown: 1
					}
					file.sortEquipmentCheckInfo2(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					let param = {
						id: item.id,
						sort: item.sort,
						id2: this.tableData[index + 1].id,
						sort2: this.tableData[index + 1].sort
					}
					file.sortEquipmentCheckInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}

			},
			getFormLength(index) {
				if (index === this.pageCount) return true;
				else return false;
			},
			getCheckList() {
				file.getByDictIdALL({
					dictId: 2,
					languageType: sessionStorage.getItem("languageType")
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				// file.getCheckList().then((response) => {
				// 	const data = response.data;
				// 	if (data.code == "1") {
				// 		this.checkList = data.data;
				// 	}
				// }).catch((response) => {
				// 	console.log(response)
				// })
			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.dialogDeviceSpots = false;
				this.tableDataEdit = {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '1',
					decimals: 0,
					defaultValue: "",
					equipmentId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
					positionCode: '0',
					monthWMes: '1',
					monthMMes: '1',
					timeLimit: '1',
          radioType: '1',
					radioNum1: null,
					radioNum2: null,
					accuracy: null
				}
				this.monthDOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
				this.checkMesList = [{
					name: '',
					check: '',
					default: ''
				}]

				this.choosePhoto = false;
				this.chooseVideo = false;
			},
			delCheckList(index) {
				this.checkMesList.splice(index, 1);
        this.tableDataEdit.radioType = '1';
			},
			checkTypeText(type) {
				if (type == '1') {
					return this.$t('label_145')
				}
				if (type == '2') {
					return this.$t('label_149')
				}
				if (type == '3') {
					return this.$t('label_141')
				}
				if (type == '4') {
					return this.$t('label_138')
				}
			},
			getEquipmentCheckInfo(param) {
				file.getEquipmentCheckInfo(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			deviceCheckItemInfoEdit(title) {
				this.getPositionList(this.searchDataList.equipmentId);
				// title 1 新增  2 编辑 3 批量修改
				if (title == '2') {
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						file.getEquipmentCheckInfoMes(this.tableDataTreeInfo.id).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.deviceParamTitle = this.$t('btn_15');
								// this.tableDataEdit = data.data;
								this.tableDataEdit.id = data.data.id
								this.tableDataEdit.equipmentTypeId = data.data.equipmentTypeId
								this.tableDataEdit.name = data.data.name
								this.tableDataEdit.method = data.data.method
								this.tableDataEdit.content = data.data.content
								this.tableDataEdit.cycleType = data.data.cycleType
								this.tableDataEdit.cycle = data.data.cycle
								this.tableDataEdit.inputType = data.data.inputType
								this.tableDataEdit.unit = data.data.unit
								this.tableDataEdit.length = data.data.length
								this.tableDataEdit.decimals = data.data.decimals
								this.tableDataEdit.defaultValue = data.data.defaultValue
								this.tableDataEdit.fileId = data.data.fileId
								if (this.tableDataEdit.fileId != "" && this.tableDataEdit.fileId != null) {
									this.chooseFile = true;
									this.showName(this.tableDataEdit.fileId)
								} else {
									this.chooseFile = false;
									this.showNameList = '';
								}
								this.tableDataEdit.needPhoto = data.data.needPhoto
								this.tableDataEdit.needPhotoNum = data.data.needPhotoNum
								this.tableDataEdit.needVideo = data.data.needVideo
								this.tableDataEdit.needVideoNum = data.data.needVideoNum
								this.tableDataEdit.sort = data.data.sort
								this.tableDataEdit.remark = data.data.remark
								this.tableDataEdit.createTime = data.data.createTime
								this.tableDataEdit.updateTime = data.data.updateTime
								this.tableDataEdit.valid = data.data.valid
								this.tableDataEdit.version = data.data.version
								this.tableDataEdit.versionFlag = data.data.versionFlag
								this.tableDataEdit.pid = data.data.pid
								this.tableDataEdit.changeState = data.data.changeState
								this.tableDataEdit.positionCode = data.data.positionCode
								this.tableDataEdit.lastCheckTime = data.data.lastCheckTime
								this.tableDataEdit.timeLimit = data.data.timeLimit
                this.tableDataEdit.radioType = data.data.radioType
								if (this.tableDataEdit.cycleType == '1') {
									if (this.tableDataEdit.cycle == '0') {
										this.tableDataEdit.cycleType = '1';
									} else {
										this.tableDataEdit.monthDMes = this.tableDataEdit.cycle.toString();
										this.tableDataEdit.cycleType = '4';
									}
								} else if (this.tableDataEdit.cycleType == '2') {
									this.tableDataEdit.weekend = this.tableDataEdit.cycle.toString()
									this.tableDataEdit.cycleType = '2';
								} else if (this.tableDataEdit.cycleType == '3') {
									let monthss = Number(this.tableDataEdit.cycle);
									if (monthss > 20) {
										this.tableDataEdit.month = this.$t('label_238')
										this.monthDOptions = ['21', '22', '23', '24', '25', '26', '27', '28', '29',
											'30', '31'
										]
									} else if (monthss > 10) {
										this.tableDataEdit.month = this.$t('label_242')
										this.monthDOptions = ['11', '12', '13', '14', '15', '16', '17', '18', '19',
											'20'
										]
									} else {
										this.tableDataEdit.month = this.$t('label_245')
										this.monthDOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
									}
									this.tableDataEdit.monthD = this.tableDataEdit.cycle.toString()
									this.tableDataEdit.cycleType = '3';
								} else if (this.tableDataEdit.cycleType == '4') {
									this.tableDataEdit.monthDMes = this.tableDataEdit.cycle.toString();
									this.tableDataEdit.cycleType = '4';
								} else if (this.tableDataEdit.cycleType == '8') {
									this.tableDataEdit.monthWMes = this.tableDataEdit.cycle.toString();
									this.tableDataEdit.cycleType = '8';
								} else if (this.tableDataEdit.cycleType == '9') {
									this.tableDataEdit.monthMMes = this.tableDataEdit.cycle.toString();
									this.tableDataEdit.cycleType = '9';
								}
								this.tableDataEdit.inputType = this.tableDataEdit.inputType.toString();
								this.tableDataEdit.method = this.tableDataEdit.method.toString();
								this.checkMesList = JSON.parse(this.tableDataEdit.defaultValue)
                if (this.tableDataEdit.inputType == '3' && this.checkMesList[0].name != '') {
									this.tableDataEdit.radioType = '2';
									this.tableDataEdit.radioNum1 = this.checkMesList[0].name;
									this.tableDataEdit.radioNum2 = this.checkMesList[1].name;
									this.tableDataEdit.accuracy = this.checkMesList[0].default;
								} else {
									this.tableDataEdit.radioType = '1';
								}
								this.choosePhoto = this.tableDataEdit.needPhoto ? true : false
								this.chooseVideo = this.tableDataEdit.needVideo ? true : false;
								this.dialogDeviceSpot = true;
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
				} else if (title == '3') {
					this.dialogDeviceSpots = true;
					if (this.tableDataEdits.cycleType == '1') {
						if (this.tableDataEdits.cycle == '0') {
							this.tableDataEdits.cycleType = '1';
						} else {
							this.tableDataEdits.monthDMes = this.tableDataEdits.cycle.toString();
							this.tableDataEdits.cycleType = '4';
						}
					} else if (this.tableDataEdits.cycleType == '2') {
						this.tableDataEdits.weekend = this.tableDataEdits.cycle.toString()
						this.tableDataEdits.cycleType = '2';
					} else if (this.tableDataEdits.cycleType == '3') {
						let monthss = Number(this.tableDataEdits.cycle);
						if (monthss > 20) {
							this.tableDataEdits.month = this.$t('label_238')
							this.monthDOptions = ['21', '22', '23', '24', '25', '26', '27', '28', '29',
								'30', '31'
							]
						} else if (monthss > 10) {
							this.tableDataEdits.month = this.$t('label_242')
							this.monthDOptions = ['11', '12', '13', '14', '15', '16', '17', '18', '19',
								'20'
							]
						} else {
							this.tableDataEdits.month = this.$t('label_245')
							this.monthDOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
						}
						this.tableDataEdits.monthD = this.tableDataEdit.cycle.toString()
						this.tableDataEdits.cycleType = '3';
					} else if (this.tableDataEdits.cycleType == '4') {
						this.tableDataEdits.monthDMes = this.tableDataEdits.cycle.toString();
						this.tableDataEdits.cycleType = '4';
					} else if (this.tableDataEdits.cycleType == '8') {
						this.tableDataEdits.monthWMes = this.tableDataEdits.cycle.toString();
						this.tableDataEdits.cycleType = '8';
					} else if (this.tableDataEdits.cycleType == '9') {
						this.tableDataEdits.monthMMes = this.tableDataEdits.cycle.toString();
						this.tableDataEdits.cycleType = '9';
					}
				} else {
					this.dialogDeviceSpot = true;
					this.deviceParamTitle = this.$t('btn_14');
					this.deviceParamTitles = this.$t('label_948');
					this.chooseFile = false;
					this.showNameList = '';
				}
			},
			tableDataEditSave() {
				this.saveLoading = true;
				if (this.tableDataEdit.name == null || this.tableDataEdit.name == '') {
					utils.messageAlert(this.$t('msg_78'), this.$t('label_358'), this.$t('label_100'));
					this.saveLoading = false;
					return;
				}
				// if (RegExp("((?=[\x21-\x7e]+)[^A-Za-z0-9])").test(this.tableDataEdit.name)) {
				// 	utils.messageAlert("点检项目不能包含特殊符号", this.$t('label_358'), this.$t('label_100'));
				// 	return;
				// }
				if (RegExp("((?=[\x21-\x7e]+)[^A-Za-z0-9])").test(this.tableDataEdit.name)) {
					utils.messageAlert(this.$t('msg_129'), this.$t('label_358'), this.$t('label_100'));
					this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.method == null || this.tableDataEdit.method == '') {
					utils.messageAlert(this.$t('msg_79'), this.$t('label_358'), this.$t('label_100'));
					this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.content == null || this.tableDataEdit.method == '') {
					utils.messageAlert(this.$t('msg_80'), this.$t('label_358'), this.$t('label_100'));
					this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.cycleType == null || this.tableDataEdit.cycleType == '') {
					utils.messageAlert(this.$t('msg_81'), this.$t('label_358'), this.$t('label_100'));
					this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.inputType == null || this.tableDataEdit.inputType == '') {
					utils.messageAlert(this.$t('msg_82'), this.$t('label_358'), this.$t('label_100'));
					this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.cycleType == "4") {
					if (isNaN(parseInt(this.tableDataEdit.monthDMes))) {
						utils.messageAlert(this.$t('input_78'), this.$t('label_358'), this.$t('label_100'));
						this.saveLoading = false;
						return;
					}
				}
				if (this.tableDataEdit.inputType == "1" || this.tableDataEdit.inputType == "2") {
					for (var i = 0; i < this.checkMesList.length; i++) {
						if (this.checkMesList[i].name == null || this.checkMesList[i].name == '') {
							utils.messageAlert(this.$t('msg_130'), this.$t('label_358'), this.$t('label_100'));
							this.saveLoading = false;
							return
						}
						if (this.checkMesList[i].check == null || this.checkMesList[i].check == '') {
							utils.messageAlert(this.$t('msg_131'), this.$t('label_358'), this.$t('label_100'));
							this.saveLoading = false;
							return
						}
					}
                    } else {
					if (this.tableDataEdit.radioType != "1") {
						if (this.tableDataEdit.accuracy == null || this.tableDataEdit.accuracy == null || this
							.tableDataEdit.radioNum1 == null || this.tableDataEdit.radioNum1 == '' || this.tableDataEdit
							.radioNum2 == null || this.tableDataEdit.radioNum2 == '') {
							utils.messageAlert(this.$t('msg_130'), this.$t('label_358'), this.$t('label_100'));
							this.saveLoading = false;
							return
						} else {
							if (Number(this.tableDataEdit.radioNum1) > Number(this.tableDataEdit.radioNum2)) {
								utils.messageAlert(this.$t('msg_237'));
								this.saveLoading = false;
								return
							}
							let radioNum1 = this.tableDataEdit.radioNum1.indexOf(".");
							let radioNum2 = this.tableDataEdit.radioNum2.indexOf(".");
							if (radioNum1 != -1) {
								let radioStr1 = this.tableDataEdit.radioNum1.split(".");
								let s1 = radioStr1[1];
								if (this.tableDataEdit.accuracy != null && this.tableDataEdit.accuracy != '' && Number(this
										.tableDataEdit.accuracy) < s1.length) {
									utils.messageAlert(this.$t('msg_237'));
									this.saveLoading = false;
									return
								} else if (Number(this.tableDataEdit.accuracy) > s1.length) {
									for (var i = 0; i < Number(this.tableDataEdit.accuracy) - s1.length; i++) {
										this.tableDataEdit.radioNum1 = this.tableDataEdit.radioNum1 + "0";
									}
								}
							} else {
								if (Number(this.tableDataEdit.accuracy) > 0) {
									this.tableDataEdit.radioNum1 = this.tableDataEdit.radioNum1 + ".";
								}
								for (var i = 0; i < Number(this.tableDataEdit.accuracy); i++) {
									this.tableDataEdit.radioNum1 = this.tableDataEdit.radioNum1 + "0";
								}
							}

							if (radioNum2 != -1) {
								let radioStr2 = this.tableDataEdit.radioNum2.split(".");
								let s2 = radioStr2[1];
								if (this.tableDataEdit.accuracy != null && this.tableDataEdit.accuracy != '' && Number(this
										.tableDataEdit.accuracy) < s2.length) {
									utils.messageAlert(this.$t('msg_237'));
									this.saveLoading = false;
									return
								} else if (Number(this.tableDataEdit.accuracy) > s2.length) {
									for (var i = 0; i < Number(this.tableDataEdit.accuracy) - s2.length; i++) {
										this.tableDataEdit.radioNum2 = this.tableDataEdit.radioNum2 + "0";
									}
								}
							} else {
								if (Number(this.tableDataEdit.accuracy) > 0) {
									this.tableDataEdit.radioNum2 = this.tableDataEdit.radioNum2 + ".";
								}
								for (var i = 0; i < Number(this.tableDataEdit.accuracy); i++) {
									this.tableDataEdit.radioNum2 = this.tableDataEdit.radioNum2 + "0";
								}
							}
						}
					}
				}
				if (this.deviceParamTitle == this.$t('btn_14')) {
					this.tableDataEdit.sort = this.pageCount + 1;
					this.tableDataEdit.equipmentId = this.searchDataList.equipmentId;
					if (this.tableDataEdit.cycleType == '1') {
						this.tableDataEdit.cycle = '0'
					} else if (this.tableDataEdit.cycleType == '2') {
						this.tableDataEdit.cycle = this.tableDataEdit.weekend
					} else if (this.tableDataEdit.cycleType == '3') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthD
					} else if (this.tableDataEdit.cycleType == '8') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthWMes;
						this.tableDataEdit.cycleType = '8';
					} else if (this.tableDataEdit.cycleType == '9') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthMMes;
						this.tableDataEdit.cycleType = '9';
					} else {
						this.tableDataEdit.cycle = this.tableDataEdit.monthDMes;
						this.tableDataEdit.cycleType = '1';
					}
                    if (this.tableDataEdit.inputType != '3') {
						this.tableDataEdit.defaultValue = JSON.stringify(this.checkMesList)
					} else {
						if (this.tableDataEdit.radioType != '1') {
							let a1 = {
								name: this.tableDataEdit.radioNum1,
								check: '0',
								default: this.tableDataEdit.accuracy
							}
							let a2 = {
								name: this.tableDataEdit.radioNum2,
								check: '1',
								default: this.tableDataEdit.accuracy
							}
							this.checkMesList = [];
							this.checkMesList.push(a1);
							this.checkMesList.push(a2);
						}
					this.tableDataEdit.defaultValue = JSON.stringify(this.checkMesList)
                    }
					this.tableDataEdit.needPhoto = this.choosePhoto ? 1 : 0;
					this.tableDataEdit.needVideo = this.chooseVideo ? 1 : 0;
					file.saveEquipmentCheckInfo(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.fatherMethod('1');
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
						this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
						this.saveLoading = false;
					})
				} else {
					if (this.tableDataEdit.cycleType == '1') {
						this.tableDataEdit.cycle = '0'
					} else if (this.tableDataEdit.cycleType == '2') {
						this.tableDataEdit.cycle = this.tableDataEdit.weekend
					} else if (this.tableDataEdit.cycleType == '3') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthD
					} else if (this.tableDataEdit.cycleType == '8') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthWMes
					} else if (this.tableDataEdit.cycleType == '9') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthMMes
					} else {
						this.tableDataEdit.cycle = this.tableDataEdit.monthDMes;
						this.tableDataEdit.cycleType = '1';
					}
                    if (this.tableDataEdit.inputType != '3') {
						this.tableDataEdit.defaultValue = JSON.stringify(this.checkMesList)
					} else {
						if (this.tableDataEdit.radioType != '1') {
							let a1 = {
								name: this.tableDataEdit.radioNum1,
								check: '0',
								default: this.tableDataEdit.accuracy
							}
							let a2 = {
								name: this.tableDataEdit.radioNum2,
								check: '1',
								default: this.tableDataEdit.accuracy
							}
							this.checkMesList = [];
							this.checkMesList.push(a1);
							this.checkMesList.push(a2);
						}
            else if (this.tableDataEdit.radioType == "1"){
              let a1 = {
                name: '',
                check: '0',
                default: ''
              }
              let a2 = {
                name: '',
                check: '1',
                default: ''
              }
              this.checkMesList = [];
              this.checkMesList.push(a1);
              this.checkMesList.push(a2);

            }
					this.tableDataEdit.defaultValue = JSON.stringify(this.checkMesList)
                    }
					this.tableDataEdit.needPhoto = this.choosePhoto ? 1 : 0;
					this.tableDataEdit.needVideo = this.chooseVideo ? 1 : 0;
					let that = this;
					file.saveEquipmentCheckInfoEdit(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.dialogDeviceSpots = false;
							that.fatherMethod('1');
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
						this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
						this.saveLoading = false;
					})
				}
				this.tableDataEdit = {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '1',
					decimals: 0,
					defaultValue: "",
					equipmentId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
					positionCode: '0',
					monthWMes: '1',
					monthMMes: '1',
					timeLimit: '1',
                    radioType: '1',
					radioNum1: null,
					radioNum2: null,
					accuracy: null
				}
				this.monthDOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
				this.checkMesList = [{
					name: '',
					check: '',
					default: ''
				}]

				this.choosePhoto = false;
				this.chooseVideo = false;
			},
			handleSelectionChange(val) {
				this.equipmentCheckInfoList = val;
			},
			tableDataEditSaves() {
				this.saveLoading = true;
				if (this.tableDataEdits.cycleType == null || this.tableDataEdits.cycleType == '') {
					utils.messageAlert(this.$t('msg_81'), this.$t('label_358'), this.$t('label_100'));
					this.saveLoadings = false;
					return;
				}
				if (this.tableDataEdits.cycleType == "4") {
					if (isNaN(parseInt(this.tableDataEdit.monthDMes))) {
						utils.messageAlert(this.$t('input_78'), this.$t('label_358'), this.$t('label_100'));
						this.saveLoadings = false;
						return;
					}
				}
				if (this.tableDataEdits.cycleType == '1') {
					this.tableDataEdits.cycle = '0'
				} else if (this.tableDataEdits.cycleType == '2') {
					this.tableDataEdits.cycle = this.tableDataEdits.weekend
				} else if (this.tableDataEdits.cycleType == '3') {
					this.tableDataEdits.cycle = this.tableDataEdits.monthD
				} else if (this.tableDataEdits.cycleType == '8') {
					this.tableDataEdits.cycle = this.tableDataEdits.monthWMes
				} else if (this.tableDataEdits.cycleType == '9') {
					this.tableDataEdits.cycle = this.tableDataEdits.monthMMes
				} else {
					this.tableDataEdits.cycle = this.tableDataEdits.monthDMes;
					this.tableDataEdits.cycleType = '1';
				}
				let that = this;
				let params = this.equipmentCheckInfoList;
				console.log('timeLimit', this.tableDataEdits.timeLimit)
				console.log('cycle', this.tableDataEdits.cycle)
				params.forEach(item => {
					item.cycleType = this.tableDataEdits.cycleType
					item.cycle = this.tableDataEdits.cycle
					item.timeLimit = this.tableDataEdits.timeLimit
				});
				// params 先取选中得数据
				// params循环  改每一项得值    选中得值
				// parmas 参数
				file.saveEquipmentCheckInfoEdits(params).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.dialogDeviceSpot = false;
						this.dialogDeviceSpots = false;
						that.fatherMethod('1');
						this.search();
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
					this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
					this.saveLoading = false;
				})

				this.tableDataEdit = {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '1',
					decimals: 0,
					defaultValue: "",
					equipmentId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
					positionCode: '0',
					monthWMes: '1',
					monthMMes: '1',
					timeLimit: '1',
				}
				this.monthDOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
				this.checkMesList = [{
					name: '',
					check: '',
					default: ''
				}]
			},
			delEquipmentTypeCheckItem() {
				let param = this.tableDataTreeInfo.id;
				let that = this;
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						file.delEquipmentCheckInfo(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.fatherMethod('1');
								that.search();
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t(
									'label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			previewFile() {
				file.selectFileType(this.tableDataEdit.fileId).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						let type = data.data;
						if (type.indexOf(".pdf") != -1) {
							this.pdfUrl = this.tableDataEdit.fileId;
							this.showPdf = true
						} else if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(
								".jpeg") != -1) {
							this.pictureUrl = this.tableDataEdit.fileId;
							this.showPicture = true
						} else {
							this.$message(this.$t('msg_9'))
						}
					} else {
						this.$message.error(this.$t('msg_10'))
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			upload(file1) {
				var formData = new FormData();
				formData.append('file', file1.file);
				formData.append('organizationId', this.deptId);
				file.upload(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.tableDataEdit.fileId = data.data
						this.showName(data.data);
						this.$message({
							message: this.$t('msg_15'),
							type: 'success'
						});
						this.chooseFile = true;
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			closePreviewClick() {
				if (this.showPdf == true) {
					this.showPdf = false
				} else if (this.showPicture == true) {
					this.showPicture = false
				}
			},
			checkInfoExportExcel() {
				let dataParam = this.searchDataList
				dataParam.versionFlag = 1
				file.checkInfoExportExcel(dataParam).then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]))
					let link = document.createElement('a')
					link.href = url
					link.download = decodeURIComponent(response.headers['content-disposition'].split('fileName=')[
						1])
					link.click()
					URL.revokeObjectURL(url)
				})
			}
		},
		created() {
			this.getCheckList();
			this.MenuRoleList = this.$store.getters.getMenu;
			this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
			this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19',
				'20'
			]);
			this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29',
				'30', '31'
			]);
		}
	}
</script>

<style scoped>
	.photoStyle {
		display: flex;
		justify-content: center;
		width: 100px;
		flex-wrap: wrap;
		text-align: center
	}

	.photoStyle .box {
		background: #43c477;
		width: 50px;
		height: 50px;
		text-align: center;
		border-radius: 5px;
		overflow: hidden;
		position: relative;
	}

	.photoStyle .box i {
		font-size: 35px;
		color: #ffffff;
		line-height: 50px;
		cursor: pointer;
	}

	.photoStyle .box.choosePhoto .choose {
		width: 0;
		height: 0;
		border-top: 25px solid red;
		border-left: 25px solid transparent;
		position: absolute;
		top: 0;
		right: 0;
	}

	.photoStyle .box.chooseVideo .choose {
		width: 0;
		height: 0;
		border-top: 25px solid red;
		border-left: 25px solid transparent;
		position: absolute;
		top: 0;
		right: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/checkItemParam.vue